exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.teams-row[data-v-a98741e2] {\n    height: 70vh;\n    overflow-y: hidden;\n    background-color: #f8f9fa;\n}\n.active[data-v-a98741e2] {\n    border-color: #017db9 !important;\n}\n", ""]);

// exports
